var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSubmittedStatus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15 8C15 11.866 11.866 15 8 15C4.13401 15 1 11.866 1 8C1 4.13401 4.13401 1 8 1C11.866 1 15 4.13401 15 8ZM16 8C16 12.4183 12.4183 16 8 16C3.58172 16 0 12.4183 0 8C0 3.58172 3.58172 0 8 0C12.4183 0 16 3.58172 16 8ZM8.18067 4.89849C8.02562 4.7116 8.01649 4.38688 8.15331 4.18378L8.18067 4.14718C8.34252 3.9521 8.6273 3.9521 8.78325 4.14029L11.8603 7.61504C11.9369 7.70735 12 7.85955 12 7.9907C12 8.12184 11.9369 8.27404 11.8544 8.37325L8.78915 11.8342C8.71358 11.9253 8.58962 12 8.48491 12C8.38749 12 8.27339 11.9353 8.19712 11.853L8.1995 11.8551L8.18067 11.8342C8.18593 11.8405 8.19142 11.8468 8.19712 11.853L8.18754 11.8444C7.98925 11.6527 8.00874 11.3207 8.16221 11.1075L8.18623 11.0764L10.4303 8.53207L4.44397 8.53214C4.22176 8.53214 4.02107 8.30364 4.00155 8.03364L4 7.9907C4 7.70244 4.21006 7.44925 4.44397 7.44925L10.4307 7.44911L8.18067 4.89849Z",
    fill: "#147582"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSubmittedStatus);
export default __webpack_public_path__ + "static/media/SubmittedStatus.b90073fc29929e47343f5dd3e2e08fa0.svg";
export { ForwardRef as ReactComponent };